import { render, staticRenderFns } from "./ExtrasForm.vue?vue&type=template&id=2ef3c29f&"
import script from "./ExtrasForm.vue?vue&type=script&lang=js&"
export * from "./ExtrasForm.vue?vue&type=script&lang=js&"
import style0 from "./ExtrasForm.vue?vue&type=style&index=0&id=2ef3c29f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports